// extracted by mini-css-extract-plugin
module.exports = {"picks":"picks_picks__oPlF6","avatarpicks":"picks_avatarpicks__2ZSEe","guesspicks":"picks_guesspicks__ApqPR","btn":"picks_btn__3pK9D"};